import { faqs } from "@/mocks/article";

export default function FAQSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          关于在线吃瓜官网，你可能想知道的
        </p>

        <div className="flex flex-col gap-4">
          {faqs.map((faq, idx) => (
            <details
              key={idx}
              className="group bg-background-200/50 rounded-xl overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-5 py-4 md:py-5 text-sm md:text-base font-medium text-foreground-100 list-none">
                <span>{faq.question}</span>
                <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center text-foreground-500 transition-transform duration-200 group-open:rotate-45">
                  <i className="ri-add-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-400 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}